import { t } from '../i18n';
import {React, useState, useEffect} from "react";

const InnerModalOpony = () => {

    return(
        <div>
            <p className="opopnytextreg"><b>{t("Szczyt sezonu na zmianę opon jest właśnie teraz!")}</b><br /><br />{t("W tym gorącym okresie prosimy o telefoniczną rezerwację wizyt.")}<br />{t("Zadzwoń pod numer ")}<b>+48 607 285 285</b>{t(", by umówić dogodny termin.")}</p>
        </div>
        
    )
}

export default InnerModalOpony;